<template>
  <div>
    <div class="cal-row">
      <div v-for="i in 14" :key="`week-day-${i}`" class="cal-col">
        {{ i % 7 | weekStr }}
      </div>
    </div>
    <div class="cal-row">
      <div v-for="(day, i) in days" :key="i" class="cal-col">
        <div :class="{ first: i % 14 === 0 }">
          {{ day.date.format('M月d') }}
          <p>{{ day.skip || '.' }}</p>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
    ok
  </div>
</template> 
 <script>
export default {
  name: 'PlantCalendar',
  props: {
    begin: {
      type: Date,
      required: false,
      default() {
        return new Date()
      },
    },
    duration: {
      type: Number,
      required: true,
    },
  },
  computed: {
    offset() {
      return this.begin.getDay()
    },
  },
  data() {
    return {
      days: [],
    }
  },
  mounted() {
    const { begin, duration, days, offset } = this
    for (let i = 1 - offset; i < 0; i++) {
      days.push({
        date: new Date(begin.getTime() + i * 24 * 3600 * 1000),
        skip: true,
      })
    }
    for (let i = 0; i < duration; i++) {
      days.push({
        date: new Date(begin.getTime() + i * 24 * 3600 * 1000),
      })
    }
  },
  filters: {
    weekStr(val) {
      return [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ][val]
    },
  },
}
</script>
<style scoped>
.cal-row {
  display: block;
  position: relative;
  box-sizing: border-box;
}
.cal-col {
  box-sizing: border-box;
  width: 7.14285714%;
  float: left;
  border-bottom: solid 1px #ccc;
  border-right: solid 1px #ccc;
}
.cal-row::after,
.cal-row::before {
  display: table;
  content: '';
}
.cal-row::after {
  clear: both;
}
.first {
  border-left: solid 1px #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/_sample/PlantCalendar.vue